function AddCOList() {
    return (
        <section className="box w-max">
            <h2>ADD CO LIST</h2>
            <div className="my-3">
                <table className="text-left add-co-list-table">
                    <thead>
                        <tr>
                            <th>Customer name</th>
                            <th>Link</th>
                            <th>Price</th>
                            <th>Market place</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <input type="text" name="customer-name" />
                            </td>
                            <td>
                                <input type="text" name="link" />
                            </td>
                            <td>
                                <input type="text" name="price" />
                            </td>
                            <td>
                                <input type="text" name="market-place" />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button className="text-[var(--blue)] underline my-3">Add more</button>
            </div>
            <div className="md:flex gap-5">
                <button className="border-2 border-[var(--black)] p-2 w-full rounded-lg">RESET</button>
                <button className="border-2 border-[var(--blue)] p-2 w-full rounded-lg text-white bg-[var(--blue)]">SUBMIT</button>
            </div>
        </section>
    );
}

export default function FeeCO() {
    return (
        <main className="max-[768px]:px-3 py-3">
            <AddCOList />
        </main>
    );
}
